// apps/app/src/core/layout/Header/RouteSelector.tsx
import { IconButton } from '@/components/ui/icon-button'
import { AppTooltip } from '@components'
import { SearchTrigger } from '@features/GlobalSearch'
import Notifications from '@features/Notifications'
import { A } from '@solidjs/router'
import { useAuth } from '@state/auth'
import {
  BookOpen,
  Calendar, ChartArea, ChessRook,
  Clapperboard,
  GraduationCap, LayoutDashboard,
  Megaphone, MessageSquare,
  Settings,
  Star, Tv
} from 'lucide-solid'
// Added Show
import { type Component, For, Show } from 'solid-js'
// Added useService and useChannels
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Divider, Grid } from 'styled-system/jsx'
import { useChannels } from '../../../state/channels/channels'; // Adjust path if needed
import Logo from './Logo'
import More from './More'

export const mainRoutes = [
  { label: 'Dashboard', href: '/', icon: LayoutDashboard },
  { label: 'Setups', href: '/setups', icon: ChartArea },
  { label: 'Chat', href: '/chat', icon: MessageSquare },
  { label: 'Recordings', href: '/recordings', icon: Tv },
  { label: 'Courses', href: '/courses', icon: GraduationCap },
  { label: 'Events', href: '/events', icon: Calendar },
  { label: 'Go Read', href: '/go-read', icon: BookOpen },
  { label: 'Go Watch', href: '/go-watch', icon: Clapperboard },
]

export const adminRoutes = [
  { label: 'Potential High Quality', href: '/potential-high-quality', icon: Star },
  { label: 'Admin', href: '/admin', icon: ChessRook },
]

export const settingRoutes = [
  { label: 'Settings', href: '/settings', icon: Settings },
]

export const RouteSelector: Component = () => {
  // Consume our new state
  const { hasUnreadChats } = useService(useChannels)()
  const { isSuper } = useService(useAuth)()

  // Added label to props
  const NavLinkSmall = (props: { href: string; icon: any; label: string }) => (
    <AppTooltip content={props.label} delay={900} positioning={{
      placement: 'right'
    }}>
      <A href={props.href}
        inactiveClass=''
        activeClass={css({
          '& button': {
            bg: 'jade.10',
            color: 'black'
          }
        })} end={props.href === '/'}>
        <IconButton
          color='fg.subtle'
          width='100%'
          size="sm"
          variant="plain"
          position="relative" // Required for absolute positioning of the dot
        >
          <props.icon />

          {/* The little red dot indicator */}
          <Show when={props.label === 'Chat' && hasUnreadChats()}>
            <Box
              position="absolute"
              top="1"
              right="1"
              width="2"
              height="2"
              bg="red.500" // Adjust to your preferred theme red if needed
              borderRadius="full"
            />
          </Show>
        </IconButton>
      </A>
    </AppTooltip>
  )

  return (
    <div class={css({ display: 'flex', gap: '1', alignItems: 'start' })}>
      <Grid>
        <Box mb='3'>
          <A href='/'>
            <Logo />
          </A>
        </Box>
        <SearchTrigger />
        <Notifications />
        <For each={mainRoutes}>
          {(route) => <NavLinkSmall {...route} />}
        </For>


        <Divider />
        <Show when={isSuper()}>
          <Grid p={1}>
            <For each={adminRoutes}>
              {(route) => <NavLinkSmall {...route} />}
            </For>
          </Grid>
        </Show>
        <More />
        <For each={settingRoutes}>
          {(route) => <NavLinkSmall {...route} />}
        </For>

      </Grid>
    </div >
  )
}
